var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React from 'react';
import classnames from 'classnames';
import { Table, Text, Link } from '@realm-kf/halcyon-components-react';
import { dataTestId } from '@hip/test-attributes';
import { _t } from '@hip/translations';
import { JrniServiceCategory } from '../../core/utils';
import styles from './appointmentSummary.css';
var SummaryTable = function (_a) {
    var appointmentSummaryTexts = _a.appointmentSummaryTexts;
    var dateString = appointmentSummaryTexts.dateString, timeString = appointmentSummaryTexts.timeString, durationString = appointmentSummaryTexts.durationString, storeName = appointmentSummaryTexts.storeName, storeHref = appointmentSummaryTexts.storeHref, firstName = appointmentSummaryTexts.firstName, lastName = appointmentSummaryTexts.lastName, email = appointmentSummaryTexts.email, mobile_prefix = appointmentSummaryTexts.mobile_prefix, mobile = appointmentSummaryTexts.mobile, category = appointmentSummaryTexts.category;
    var tableHeaders = [
        _t('appointment_booking.appointment_summary.fields.date_and_time'),
        _t('appointment_booking.appointment_summary.fields.duration'),
        _t('appointment_booking.appointment_summary.fields.your_details'),
    ];
    var tableData = __spreadArray(__spreadArray([
        ["".concat(dateString, "\n").concat(timeString)],
        [durationString]
    ], [
        [
            React.createElement("div", { key: storeName },
                React.createElement(Text, { block: true, space: "xsmall", "data-testid": dataTestId.ab.confirmationDetails.selectedStore }, storeName),
                category !== JrniServiceCategory.Online && (React.createElement(Link, { href: storeHref, linkUnderline: true, inNewTab: true, "data-testid": dataTestId.ab.confirmationDetails.selectedStoreLink }, _t('appointment_booking.appointment_summary.full_store_info_and_facilities')))),
        ],
    ], false), [
        ["".concat(firstName, " ").concat(lastName, "\n").concat(email, "\n").concat(mobile_prefix).concat(mobile)],
    ], false);
    return (React.createElement("div", { className: classnames(styles.Table, 'hlcn-u-bgc-light'), "data-testid": dataTestId.ab.confirmationDetails.confirmationTableDesktop },
        React.createElement(Table, { accessibilityText: _t('appointment_booking.appointment_summary.table_caption'), heading: tableHeaders, data: tableData, headingLeft: true })));
};
export { SummaryTable };
